import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface firmwareCampaignStopState {
  isLoading: boolean
  error: string | undefined
  campaignStopData: boolean | undefined
  httpStatus: number | undefined
}

export const initialState: firmwareCampaignStopState = {
  isLoading: true,
  error: undefined,
  campaignStopData: false,
  httpStatus: 0
}

const firmwareCampaignStopSlice = createSlice({
  name: 'firmwareCampaignStop',
  initialState,
  reducers: {
    firmwareCampaignStopLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        campaignStopData: undefined,
        httpStatus: 0
      }
    },
    firmwareCampaignStopUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        campaignStopData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    firmwareCampaignStopErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        campaignStopData: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  firmwareCampaignStopLoadingAction,
  firmwareCampaignStopUpdateAction,
  firmwareCampaignStopErrorAction
} = firmwareCampaignStopSlice.actions

export default firmwareCampaignStopSlice.reducer
